export const styles = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FEFEFE',
    boxShadow: '0px 4px 4px 0px #000000',
    padding: '40px 56px',
    width: '632px',
    borderRadius: '8px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '900',
    marginBottom: '20px',
    textAlign: 'center',
    fontFamily: "'Proxima Nova Alt', 'Open Sans', 'Montserrat', sans-serif",
  },
  boldText: { fontSize: '16px', fontWeight: '600', marginBottom: '8px' },
  label: { fontSize: '14px', fontWeight: '400', minWidth: '100px' },
  groupSelect: {
    height: 'auto',
    maxWidth: '100%',
  },
  placeholdersLabel: {
    minWidth: '130px',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
  button: {
    minWidth: '60px',
    fontSize: '14px',
    fontWeight: '500',
    border: '1px solid',
    padding: '10px 30px',
    borderRadius: '16px',
  },
  textarea: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid gray',
    padding: '20px 16px',
    fontSize: '14px',
  },
  nameInput: {
    width: '300px',
    height: '22px',
    backgroundColor: '#C4C4C421',
    paddingLeft: '10px',
    marginLeft: 20,
  },
  senderSelector: {
    width: '120px',
    height: '22px',
    fontSize: '14px',
    color: '#8F8F8F',
    backgroundColor: 'transparent',
    marginLeft: '20px',
    marginBottom: 10,
  },
  wrapperSelect: {
    '& .MuiInput-root': {
      fontSize: '14px',
    },
  },
  input: {
    width: '100%',
    height: '30px',
    fontSize: '14px',
  },
  buttonOpen: { fontSize: '10px', color: '#7C7C7C', width: '100px' },
  inputContainer: {
    paddingTop: '6px',
  },
  messageInput: {
    width: '100%',
  },
  titleAndBodyLabel: {
    fontSize: '14px',
    fontWeight: '400',
    marginBottom: '10px',
  },
  titleAndBodyInputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    border: '1px solid #E2E2FC',
    borderRadius: '8px',
    '& fieldset': {
      border: '0px',
    },
    '& .MuiOutlinedInput-root': {
      display: 'flex',
      alignItems: 'baseline',
      padding: '10px 14px',
    },
  },
  emojiPicker: {
    paddingTop: '6px',
    paddingRight: '5px',
  },
  titleInput: {
    width: '100%',
    minHeight: '64px',
    fontSize: '14px',
  },
  bodyInput: {
    width: '100%',
    minHeight: '112px',
    fontSize: '14px',
  },

  footer: {
    marginTop: '10px',
  },
  spaceBetween: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  menuItem: {
    fontSize: 12,
  },
  error: {
    fontSize: 12,
    color: '#f44336',
    marginTop: '-8px',
    marginBottom: 8,
  },
}
